<template>
    <div class="layout__padding-clear colour__background__grey-262636 layout__overflow-hidden">
        <div v-show="this.viewComponent === 'bill-wych'">
            <BillWych></BillWych>
        </div>

        <div v-show="this.viewComponent === 'lawrence-rand'">
            <LawrenceRand></LawrenceRand>
        </div>

        <div v-show="this.viewComponent === 'boomerang'">
            <Boomerang></Boomerang>
        </div>

        <div v-show="this.viewComponent === 'sawyde-harris'">
            <SawydeHarris></SawydeHarris>
        </div>

        <div v-show="this.viewComponent === 'sensier'">
            <Sensier></Sensier>
        </div>

        <div v-show="this.viewComponent === 'spinning-acres'">
            <SpinningAcres></SpinningAcres>
        </div>

        <div v-show="this.viewComponent === 'connells'">
            <Connells></Connells>
        </div>


    </div>

</template>

<script>
    import Router from '../../../router';
    import BillWych from '../../../components/productServices/studio/BillWych.vue';
    import LawrenceRand from '../../../components/productServices/studio/LawrenceRand.vue';
    import Boomerang from '../../../components/productServices/studio/Boomerang.vue';
    import SawydeHarris from '../../../components/productServices/studio/SawydeHarris.vue';
    import Sensier from '../../../components/productServices/studio/Sensier.vue';
    import SpinningAcres from '../../../components/productServices/studio/SpinningAcres.vue';
    import Connells from '../../../components/productServices/studio/Connells.vue';

    export default {
        name: "outWorkShowcase",
        props: {},
        components: {
            BillWych,
            LawrenceRand,
            Boomerang,
            SawydeHarris,
            Sensier,
            SpinningAcres,
            Connells
        },
        mixins: [],
        data() {
            return {
                viewComponent: ''
            }
        },
        created() {

            this.viewComponent = this.$route.query.client
        },
        methods: {
            contactUs() {
                Router.push({
                    name: '/contact'
                });
            },
            print() {
                Router.push({
                    name: '/products/print'
                });
            },
            digital() {
                Router.push({
                    name: '/products/print'
                });
            }
        },
    };
</script>